import useSWR from 'swr';
import { PaymentEntityType, RefundOverviewData, RefundOwnerType, RefundsService } from '../api';

export const useRefundOverview = (ownerType: RefundOwnerType | undefined, ownerId: string | undefined) => {
  const { data, mutate } = useSWR(
    ownerType && ownerId ? { opId: 'getRefundOverview', ownerType, ownerId } : null,
    (key) => RefundsService.getRefundOverview(key.ownerType, key.ownerId),
    { revalidateOnFocus: false },
  );
  return { overview: data, mutate };
};

export const findRefundItem = (
  overview: RefundOverviewData | undefined,
  entityType: PaymentEntityType,
  entityId: string | undefined,
) => {
  const matchingItems = overview?.payments?.filter(
    (item) => item.entity_type === entityType && item.entity_id === entityId,
  );
  return matchingItems?.find((item) => !item.disabled_reason) ?? matchingItems?.[0];
};
